import { render, staticRenderFns } from "./_products.vue?vue&type=template&id=d51631c6&scoped=true"
import script from "./_products.vue?vue&type=script&lang=js"
export * from "./_products.vue?vue&type=script&lang=js"
import style0 from "./_products.vue?vue&type=style&index=0&id=d51631c6&prod&scoped=true&lang=css"
import style1 from "./_products.vue?vue&type=style&index=1&id=d51631c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51631c6",
  null
  
)

export default component.exports